<template>
  <div>
    <main class="home">
      <home-slider v-if="!this.containerLocked" :sliders="slides" />

      <div
        ref="container"
        :class="[{ 'home__fixed-container--fixed': this.containerLocked }, 'home__fixed-container']"
      >
        <main-header :fixed="containerLocked" />
        <filter-country
          @onSelectFilter="handlerFilter($event)"
          :text="$tc('generals.seework', 0)"
          class="home__filter"
        />
        <grid-posts-home :items="gridItems" />
        <scroll-to />
      </div>
    </main>
    <main-footer ref="footer" v-show="footerStyles.visible" style="bottom: 0;" />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
let hasLastPosition = null;

export default {
  name: "home",
  data() {
    return {
      slides: [],
      gridItems: [],
      footerStyles: {
        visible: false,
      },
    };
  },

  computed: {
    containerLocked() {
      return this.$store.state.ui.containerLocked;
    },
  },

  mounted() {
    this.$hub.$on("hideSlider", this.hideSlider);
    this.$hub.$on("setPositionFooter", this.setPositionFooter);
    document.dispatchEvent(new Event("prerender-ready"));

    this.getData();

    this.$hub.$on("repeatRequests", this.getData);
    this.$store.dispatch("setFilter", "");
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === "work" || from.name === "SingleNews") {
      hasLastPosition = true;
    }

    next();
  },

  methods: {
    getData(language = this.$store.state.ui.language, filters) {
      this.$store.dispatch("setLoading", true);

      this.$home
        .getData(language, filters)
        .then((response) => {
          const { sliders, gridItems } = response.data;

          this.slides = [];
          this.$nextTick(() => {
            this.slides = sliders;
            this.gridItems = gridItems;
          });
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);

          if (hasLastPosition && this.$store.state.ui.lastWindowPosition > 0) {
            setTimeout(() => {
              this.hideSlider();
              setTimeout(() => {
                $("body, html").scrollTop(this.$store.state.ui.lastWindowPosition);
              }, 650);
            }, 80);
          }
        });
    },

    hideSlider() {
      $("html, body").animate(
        {
          scrollTop: $(this.$refs.container).offset().top,
        },
        300,
        () => {
          $("body, html").animate({ scrollTop: 0 }, 0, () => {
            this.$store.dispatch("setContainerLocked", true);
            this.setPositionFooter();
          });
        }
      );
    },

    setPositionFooter() {
      if (this.containerLocked) {
        this.footerStyles.visible = true;
      }
    },

    handlerFilter(obj) {
      this.$store.dispatch("setFilter", obj.id);
      this.$router.push("works");
    },
  },
};
</script>

<style lang="scss">
.home {
  transform-origin: top;

  &__fixed-container {
    width: 100%;
    position: relative;
    height: 100%;
    top: calc(100vh - 60px);
    background: white;
    z-index: 2;
    overflow: hidden;
    margin-bottom: 300px;

    &--fixed {
      top: 0;
      padding-top: 60px;
      overflow: auto;
      overflow-x: hidden;
    }
  }

  &__filter {
    margin: 80px 0;
  }
}

@media (max-width: 1000px) {
  .home {
    padding-bottom: 290px;

    &__fixed-container {
      position: absolute;
      top: 91%;
      margin-bottom: 0;

      &--fixed {
        top: 0 !important;
        position: relative;
      }
    }
  }
}
</style>
